const API_BASE_URL = process.env.REACT_APP_API_BASE_URL ?? 'http://localhost:5000';

async function handleResponse(response: Response) {
  if (!response.ok) {
    const errorBody = await response.json().catch(() => ({}));
    const message = errorBody.message || 'Something went wrong';
    throw new Error(message);
  }
  return response.json();
}

export async function submitContactForm(payload: {
  name: string;
  email: string;
  subject: string;
  message: string;
}) {
  const response = await fetch(`${API_BASE_URL}/api/contact`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload)
  });
  return handleResponse(response);
}

export async function submitJobApplication(formData: FormData) {
  const response = await fetch(`${API_BASE_URL}/api/applications`, {
    method: 'POST',
    body: formData
  });
  return handleResponse(response);
}

